import * as React from 'react';
import { useSelector, useDispatch } from "react-redux";
import CommonTable from "../table";
import { deleteVendorFeesAction, getVendorFeesAction } from "../../containers/dashboard/action";
import ShopFeesModal from '../countries/ShopFeesModal';
import { makeStyles } from '@material-ui/core';
import theme from '../../theme';
import { Pagination } from '@material-ui/lab';
import CommonButton from '../button';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    width: "100%",
    minHeight: "calc(100vh - 175px)",
    padding: "45px 90px",
    marginLeft: "220px",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .title": {
      color: theme.colors.Violet,
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      fontSize: "24px",
    },
  },
  headerName: {
    fontSize: "13px",
    fontFamily: theme.fontFamily.MARKPROHEAVY,
    opacity: "0.3",
    color: theme.colors.Violet,
  },
  Tab: {
    position: "relative",
    top: "10px",
    left: "-22px",
    cursor: "pointer",
    "& .tableTitle": {
      borderRadius: "10px 10px 0px 0px",
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      fontSize: "16px",
      color: theme.colors.DodgerBlue,
      cursor: "pointer",
      padding: "15px 25px",
      top: `50%`,
      left: `15%`,
      transform: `translate(-50%,-50%)`,
      position: "absolute",
    },
  },
  tableContainer: {
    marginTop: "30px",
  },
  tableHeader: {
    color: theme.colors.Violet,
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
    fontSize: "20px",
    marginBottom: "15px",
    marginTop: "40px",
  },
  listContainer: {
    marginTop: "30px",
    "& .block": {
      cursor: "pointer",
      background: theme.colors.White,
      boxShadow: "0px 2px 15px #D0CFDB99",
      borderRadius: "15px",
      padding: "15px 30px",
      display: "flex",
      marginBottom: "15px",
      alignItems: "center",
      justifyContent: "space-between",
      "& .left": {
        flex: "0.7",
        display: "flex",
        alignItems: "center",
        "& .countryInfoContainer": {
          marginLeft: "25px",
          color: theme.colors.Violet,
          "& .countryName": {
            fontSize: "22px",
            fontFamily: theme.fontFamily.MARKPROBOLD,
            marginBottom: "10px",
          },
          "& .countryCurrencies": {
            fontSize: "14px",
            fontFamily: theme.fontFamily.MARKPRO,
            color: theme.colors.DodgerBlue,
          },
        },
      },
      "& .right": {
        flex: "0.3",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      },
    },
  },
  currency: {
    fontSize: "8px",
    position: "relative",
    bottom: "3px",
    marginRight: "2px",
  },
  successTube: {
    color: "#22D559",
    fontSize: "10px",
    fontFamily: theme.fontFamily.MARKPROBOLD,
    borderRadius: "14px",
    backgroundColor: "#E4FDEC",
    textAlign: "center",
    padding: "2px 8px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  editLabel: {
    cursor: "pointer",
    color: theme.colors.DodgerBlue,
    marginRight: "10px",
    fontFamily: theme.fontFamily.MARKPROHEAVY,
    display: "flex",
    alignItems: "center",
  },
  deleteLabel: {
    cursor: "pointer",
    color: theme.colors.Pomegranate,
    fontFamily: theme.fontFamily.MARKPROHEAVY,
  },
  wrapIcon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export default function VendorFeesTab({ vendor_id }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const dashboardReducer = useSelector((state) => state.dashboardReducer);
  const deleteVendorFeesMethod = React.useCallback(
    (data) => dispatch(deleteVendorFeesAction(data)),
    [dispatch]
  )
  const [openShopFeesModal, setOpenShopFeesModal] = React.useState(false);
  const [editShopFeesData, setEditShopFeesData] = React.useState(null);
  const prevCreateVendorFeesSuccessRef = React.useRef(false);
  const prevUpdateVendorFeesSuccessRef = React.useRef(false);
  const prevDeleteVendorFeesSuccessRef = React.useRef(false);
  const [vendorFeesPage, setVendorFeesPage] = React.useState(1);
  const [vendorFeesTotalPage, setVendorFeesTotalPage] = React.useState(1);
  const page_size = 10;
  const getVendorFeesMethod = React.useCallback(
    (data) => dispatch(getVendorFeesAction(data)), [dispatch]);

  React.useEffect(() => {
    const {
      vendorFees,
      createVendorFeesSuccess,
      updateVendorFeesSuccess,
      deleteVendorFeesSuccess,
    } = dashboardReducer;

    const currentCreateSuccess = !!createVendorFeesSuccess;
    const currentUpdateSuccess = !!updateVendorFeesSuccess;
    const currentDeleteSuccess = !!deleteVendorFeesSuccess;

    if (currentCreateSuccess && !prevCreateVendorFeesSuccessRef.current) {
      prevCreateVendorFeesSuccessRef.current = true;
      getVendorFeesMethod({ page: vendorFeesPage, page_size, vendor: vendor_id });
    } else if (!currentCreateSuccess) {
      prevCreateVendorFeesSuccessRef.current = false;
    }

    if (currentUpdateSuccess && !prevUpdateVendorFeesSuccessRef.current) {
      prevUpdateVendorFeesSuccessRef.current = true;
      getVendorFeesMethod({ page: vendorFeesPage, page_size, vendor: vendor_id });
    } else if (!currentUpdateSuccess) {
      prevUpdateVendorFeesSuccessRef.current = false;
    }

    if (currentDeleteSuccess && !prevDeleteVendorFeesSuccessRef.current) {
      prevDeleteVendorFeesSuccessRef.current = true;
      getVendorFeesMethod({ page: vendorFeesPage, page_size, vendor: vendor_id });
    } else if (!currentDeleteSuccess) {
      prevDeleteVendorFeesSuccessRef.current = false;
    }

    if (vendorFees?.count) {
      setVendorFeesTotalPage(Math.ceil(vendorFees.count / page_size));
    } else if (Array.isArray(vendorFees) && vendorFees.length) {
      // If history=true is used, it returns a list directly
      setVendorFeesTotalPage(1);
    }
  }, [dashboardReducer, vendor_id, dashboardReducer, page_size, vendorFeesPage, getVendorFeesMethod])
  React.useEffect(() => {
    getVendorFeesMethod({ page: vendorFeesPage, page_size, vendor: vendor_id });
  }, [dashboardReducer?.deleteVendorFeesError, dashboardReducer?.deleteVendorFeesSuccess]);


  return (
    <>
      <div>
        <CommonButton
          type="button"
          text={"Set Up Shop Fees"}
          stylevariant="secondary4"
          onClick={() => {
            setOpenShopFeesModal(true);
            setEditShopFeesData(null);
          }}
          style={{ padding: "5px 40px" }}
          fontSize="18px"
          fontFamily={theme.fontFamily.MARKPROHEAVY}
        />
      </div>
      <div className={classes.tableContainer}>
        <CommonTable
          columns={[
            {
              Header: "Start Range",
              accessor: "start_range",
              HeaderCell: (data) => {

                return <div className={classes.headerName}>{data}</div>;
              },
              Cell: (data) => {
                console.log(data)
                return <span>{data || "0"}</span>;
              },
            },
            {
              Header: "End Range",
              accessor: "end_range",
              HeaderCell: (data) => {
                return <div className={classes.headerName}>{data}</div>;
              },
              Cell: (data) => {
                return <span>{data || "0"}</span>;
              },
            },
            {
              Header: "Fee",
              accessor: "fee",
              HeaderCell: (data) => {
                return <div className={classes.headerName}>{data}</div>;
              },
              Cell: (data) => {
                return <span>{data || "0"}</span>;
              },
            },
            {
              Header: "",
              accessor: "id",
              HeaderCell: (data) => {
                return <div className={classes.headerName}>{data}</div>;
              },
              Cell: (data, row) => {
                return (
                  <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                    <div
                      className={classes.editLabel}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenShopFeesModal(true);
                        setEditShopFeesData(row);
                      }}
                    >
                      <img
                        src={"/images/editIcon.svg"}
                        style={{ marginRight: "8px", marginBottom: "3px" }}
                        alt="icon"
                      />{" "}
                      Edit Shop Fees
                    </div>
                    <div
                      className={classes.deleteLabel}
                      onClick={(e) => {
                        e.stopPropagation();

                        deleteVendorFeesMethod(row.id);

                      }}
                    >
                      Remove
                    </div>
                  </div>
                );
              },
            },
          ]}
          data={
            Array.isArray(dashboardReducer?.vendorFees)
              ? dashboardReducer.vendorFees
              : dashboardReducer?.vendorFees?.data || []
          }
          loading={dashboardReducer?.loading}
        />

        {(Array.isArray(dashboardReducer?.vendorFees) && dashboardReducer.vendorFees.length) ||
          dashboardReducer?.vendorFees?.data?.length ? (
          <div className={"pagination"}>
            <Pagination
              page={vendorFeesPage}
              count={vendorFeesTotalPage}
              showFirstButton
              showLastButton
              onChange={(event, value) => {
                setVendorFeesPage(value);
              }}
            />
          </div>
        ) : null}

      </div>
      <ShopFeesModal
        openModal={openShopFeesModal}
        editData={editShopFeesData}
        onClose={() => {
          setOpenShopFeesModal(false);
          setEditShopFeesData(null);
        }}
        vendor_id={vendor_id}
      />
    </>
  )
}